//输入防抖
let timeout = null;

const debounce = (cb, wait = 500) => {
  if (timeout !== null) clearTimeout(timeout);
  timeout = setTimeout(() => {
    timeout = null
    cb && cb()
  }, wait);
}

export default debounce


// WEBPACK FOOTER //
// ./src/util/debounce.js